/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImplantOrder from './implant-order';
import ImplantOrderDetail from './implant-order-detail';
import ImplantOrderUpdate from './implant-order-update';
import ImplantOrderDeleteDialog from './implant-order-delete-dialog';

const ImplantOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImplantOrder />} />
    <Route path="new" element={<ImplantOrderUpdate />} />
    <Route path=":id">
      <Route index element={<ImplantOrderDetail />} />
      <Route path="edit" element={<ImplantOrderUpdate />} />
      <Route path="delete" element={<ImplantOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImplantOrderRoutes;
